'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { PhnxSponsorSlider } from './SponsorSlider'
import { SponsorSliderProps } from './SponsorSlider'

interface SponsorSliderBlokProps {
  blok: {
    title: SponsorSliderProps['title']
    sponsors: any[]
    slidesPerView: SponsorSliderProps['slidesPerView']
    disableAutoPlay: SponsorSliderProps['autoplay']
  } & SbBlokData
}

const SponsorSlider: FC<SponsorSliderBlokProps> = ({ blok }) => {
  const [items, setItems] = useState<any[]>([]) // Initialize as an array

  useEffect(() => {
    if (Array.isArray(blok.sponsors)) {
      // Check if blok.items is an array
      const itemsArray = blok.sponsors.map((item: any) => ({
        link: item.link,
        src: item.asset?.filename, // Use optional chaining for safety
      }))
      setItems(itemsArray)
    }
  }, [blok.sponsors])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxSponsorSlider
        title={blok.title}
        sponsors={items}
        slidesPerView={blok.slidesPerView}
        autoplay={blok.disableAutoPlay}
      />
    </div>
  )
}

export default SponsorSlider
